<template lang="pug">
v-container
	v-row
		v-col
			v-menu(v-model="date_menu" :close-on-content-click="true" min-width="auto")
				template(v-slot:activator="{on,attrs}")
					v-text-field(v-bind="attrs" v-on="on" :value="survey.date" label="日期" prepend-icon="mdi-calendar-range")
				v-date-picker(locale="zh-cn" v-model="survey.date")
				v-layout
					v-btn(dark block @click="date_menu=false").ma-0.blue 確認
		v-col
			v-menu(v-model="time_menu" :close-on-content-click="false" min-width="auto")
				template(v-slot:activator="{on,attrs}")
					v-text-field(v-bind="attrs" v-on="on" :value="survey.time" label="時間" prepend-icon="mdi-clock-outline")
				v-time-picker(locale="zh-cn" v-model="survey.time")
				v-layout
					v-btn(dark block @click="time_menu=false").ma-0.blue 確認
		//- v-col
		//- 	v-select(label="類別" :items="categories" v-model="survey.category" @change="getSurvey()")
		//- v-col
		//- 	v-select(label="身分" :items="identities" item-text="text" item-value="value" v-model="survey.identity" @change="getSurvey()")
		//- v-col
		//- 	v-select(:label="survey.category" :items="targets" v-model="survey.target")
		v-col
			v-select(label="路線" :items="routes" item-text="text" item-value="value" v-model="survey.route" @change="getSurvey()")
	v-layout(row wrap v-for="(qs,qi) in questions" :key="qi").my-3
		v-flex(xs12 md6 :style="inputStyle(qs)").d-flex.align-center
			span.px-5.py-2.subheading {{qs.q}}
		v-flex(xs12 md6 v-if="qs.type.includes('單選題')")
			v-btn.ma-1(v-for="(opt,oi) in qs.opts" :key="oi" @click="qs.select=opt" :style="radioStyle(opt,qs)")
				.badge(:style="{background: qs.color.p}") {{String.fromCharCode(97 + oi).toUpperCase()}}
				span {{opt.t}}
			v-btn.ma-1(v-if="qs.type.includes('其他')" @click="qs.select = null; qs.isOtherSelected = true" :style="otherRadioStyle(qs)")
				.badge(:style="{background: qs.color.p}") 其他
				input(type="text" v-model="qs.other" @input="qs.select=null" :style="{borderColor: qs.color.p}").bdr.text-xs-center
		v-flex(xs12 md6 v-else-if="qs.type.includes('複選題')")
			v-layout(row wrap align-center justify-start).px-5.pt-4
				v-checkbox.mt-0(style="height:40px" v-for="(opt,oi) in qs.opts" :key="oi" v-model="qs.select" :value="opt.option_id" :label="opt.t" :color="qs.color.p")
				v-checkbox.mt-0.ml-4(v-if="qs.type.includes('其他')" v-model="qs.otherChecked" :color="qs.color.p" hide-details style="height:40px")
					template(v-slot:label)
						span.mr-2.text-no-wrap 其他
						input(type="text" v-model="qs.other" :style="{borderColor: qs.color.p}" placeholder="請填寫").bdr.text-xs-center(style="min-width:120px")
		v-flex(xs12 md6 v-else)
			v-layout(v-if="qs.type=='評分'" :style="inputStyle(qs)" align-center).px-3
				.badge(:style="{background: qs.color.p}") 評分
				v-slider(thumb-label="always" :color="qs.color.p" :max="qs.max" :min="qs.min" v-model.number="qs.select").mx-3
			.pa-2(v-if="qs.type=='簡答'")
				.badge(:style="{background: qs.color.p}") 簡答
				input(type="text" v-model="qs.select").bdr.text-xs-center
			.bdr(v-if="qs.type=='文字詳述'" :style="inputStyle(qs)").pa-2
				textarea.input(v-model="qs.select" style="background: #fff")
	.psf-center(v-if="questions.length==0")
		h1 點選身分開始
	v-layout.psf
		v-btn.ma-1(fab @click="save()")
			v-icon mdi-check
	v-snackbar(v-model="snackbar" :timeout="1000") 儲存成功
</template>

<script>
import { db, colors } from '../main';
import axios from 'axios';

export default {
    name: 'write',
    data() {
        return {
            colors,
            date_menu: false,
            time_menu: false,
            snackbar: false,
            survey: { account: '', date: '', time: '', category: '', target: '', identity: '', route: '', items: [] },
            categories: [],
            targets: [],
            identities: [],
            routes: [],
            questions: [],
        };
    },
    methods: {
        // 產生輸入框顏色
        inputStyle(qs) {
            return { background: qs.color.l, color: qs.color.d, borderColor: qs.color.p };
        },
        // 單選/多選樣式(是否被選種)
        radioStyle(opt, qs) {
            return {
                color: qs.select == opt ? 'white' : qs.color.p,
                background: qs.select == opt ? qs.color.p : 'white',
                borderColor: qs.color.p,
            };
        },
        // 題目類型ID對應中文
        getTypeName(typeId) {
			const typeMap = {
				1: '配分單選題',
				2: '單選題',
				3: '複選題',
				4: '評分',
				5: '簡答',
				6: '文字詳述',
                7: '單選題與其他',
                8: '複選題與其他',
			};
			const result = typeMap[typeId] || '配分單選題';
			return result;
		},
        parseColor(colorStr) {
            // 預設顏色
            if (!colorStr) {
                return { p: '#00bcd4', l: '#b2ebf2', d: '#006064' };
            }
            
            const foundColor = this.colors.find(c => c.p === colorStr);
            if (foundColor) {
                return foundColor;
            }
            
            // 將十六進制顏色代碼轉換成RGB
            const rgb = this.hexToRgb(colorStr);
            if (rgb) {
                return {
                    p: colorStr,
                    l: this.rgbToHex(Math.min(255, rgb.r + 100), Math.min(255, rgb.g + 100), Math.min(255, rgb.b + 100)),
                    d: this.rgbToHex(Math.max(0, rgb.r - 50), Math.max(0, rgb.g - 50), Math.max(0, rgb.b - 50))
                };
            }
            
            return { p: colorStr, l: '#b2ebf2', d: '#006064' };
        },
        // 解析十六進制顏色代碼
        hexToRgb(hex) {
            if (!hex) return null;
            
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        // RGB轉回十六進制顏色代碼
        rgbToHex(r, g, b) {
            return "#" + ((1 << 24) + (Math.round(r) << 16) + (Math.round(g) << 8) + Math.round(b)).toString(16).slice(1);
        },
        otherRadioStyle(qs) {
            const active = qs.isOtherSelected && !qs.select;
            return {
                color: active ? 'white' : qs.color.p,
                background: active ? qs.color.p : 'white',
                borderColor: qs.color.p,
            };
        },
        // 計算今年年分
        getCurrentRocYear() {
            const now = new Date();
            return now.getFullYear() - 1911;
        },
        async loadRouteList() {
            // 取得路線列表
            const routeResponse = await axios.get('/api/Account/RouteList');
            if (routeResponse.data.status && routeResponse.data.result) {
                this.routes = routeResponse.data.result.map(route => ({
                    text: route.name,
                    value: route.id,
                    identity_id: route.identity_id,  
                }));
            } else {
                this.routes = [];
            }
        },
        // 取得問卷題目
        async getSurvey() {
            if (!this.survey.route) {
                this.questions = [];
                return;
            }

            const selectedRouteId = parseInt(this.survey.route, 10);
            const selectedRoute = this.routes.find(r => parseInt(r.value, 10) === selectedRouteId);

            if (!selectedRoute || !selectedRoute.identity_id) {
                // 找不到對應身分就沒有問卷
                this.questions = [];
                return;
            }

            const identityId = parseInt(selectedRoute.identity_id, 10);
            this.survey.identity = identityId;

			const year = this.getCurrentRocYear();

            try {
                const response = await axios.get('/api/Questionnaire/QuestionnaireList',{
					params: {
						year,
						identity_id: identityId
					}
				});
                
                if (response.data.status && response.data.result) {
                    // 用身分ID找到對應的問卷
                    // const identityId = parseInt(this.survey.identity);
                    const questionnaire = response.data.result.find(q => q.identity_id === identityId);
                    
                    if (questionnaire) {
                        if (questionnaire.questions && questionnaire.questions.length > 0) {
                            const convertedQuestions = questionnaire.questions.map((q) => {
                                try {
                                    // 轉換選項格式
                                    const opts = (q.options || []).map(opt => ({
                                        t: opt.option_name || '',
                                        s: opt.score || 0,
                                        option_id: opt.option_id || 0
                                    }));
                                    
                                    const typeName = this.getTypeName(q.questionnaire_type_id) || '配分單選題';
                                    const colorObj = this.parseColor(q.color);
                                    
                                    const convertedQuestion = {
                                        q: q.question_name || '',
                                        index: q.tag || '',
                                        category: q.category_id || null,
                                        type: typeName,
                                        color: colorObj,
                                        opts: opts.length > 0 ? opts : [{ t: '', s: 0 }],
										select: typeName.includes('複選題') ? [] : null, 
                                        other: '',
                                        max: 100,
                                        otherChecked: false,
                                        isOtherSelected: false,
                                        min: 0,
                                        quota: 5,
                                        max_score: q.max_score || 0,
                                        question_id: q.question_id,
                                        questionnaire_id: q.questionnaire_id
                                    };
                                    
                                    // 回傳轉換後的題目
                                    return convertedQuestion;
                                } catch (error) {
                                    console.error('轉換問題時發生錯誤:', error);
                                    return null;
                                }
                            }).filter(q => q !== null);
                            
                            // 題目排序
                            convertedQuestions.sort((a, b) => {
                                const questionA = questionnaire.questions.find(q => q.question_id === a.question_id);
                                const questionB = questionnaire.questions.find(q => q.question_id === b.question_id);
                                const sortA = questionA ? questionA.sort : 0;
                                const sortB = questionB ? questionB.sort : 0;
                                return sortA - sortB;
                            });
                            
                            this.questions = convertedQuestions;
                            this.$nextTick(() => {
                                this.$forceUpdate();
                            });
                        } else {
                            this.questions = [];
                        }
                    } else {
                        this.questions = [];
                    }
                } else {
                    this.questions = [];
                }
            } catch (error) {
                console.error('載入問卷錯誤:', error);
                this.questions = [];
            }
        },
        // 儲存問卷答案
        async save() {
			const year = this.getCurrentRocYear();
            if (!this.survey.date || !this.survey.time || !this.survey.identity || !this.survey.route) {
                const missingFields = [];
                if (!this.survey.date) missingFields.push('日期');
                if (!this.survey.time) missingFields.push('時間');
                if (!this.survey.identity) missingFields.push('身分');
                if (!this.survey.route) missingFields.push('路線');
                alert(missingFields.join('、') + '未填寫');
                return;
            }

            try {
                const questionnaireId = this.questions.length > 0 ? this.questions[0].questionnaire_id : 0;

                const [hours, minutes] = this.survey.time.split(':');
                const fillDateTime = new Date(this.survey.date);
                fillDateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);

                const answers = this.questions.flatMap(q => {
                    const base = {
                        questionnaire_question_id: q.question_id || 0,
                        route_id: parseInt(this.survey.route),
                        identity_id: parseInt(this.survey.identity),
                    };
                    // 複選題
                    if (q.type.includes('複選題')) {
                        const selected = Array.isArray(q.select) ? q.select : [];
                        const optionAnswers = selected
                            .map(optionId => ({ ...base, answer: String(optionId) }))
                            .filter(x => x.answer && x.answer !== '0');
                        // 將其他欄位內容另存一筆答案
                        if (q.type.includes('其他') && q.otherChecked && q.other && q.other.trim()) {
                            optionAnswers.push({ ...base, answer: `其他:${q.other.trim()}` });
                        }
                        return optionAnswers;
                    }
                    // 單選題
                    if (q.type.includes('單選題')) {
                        const answerValue = q.select?.option_id ? String(q.select.option_id) : '';
                        let finalAnswer = answerValue;
                        // 單選題與其他：將「其他」欄位內容存進同一筆答案
                        if (q.type.includes('其他') && q.other && q.other.trim()) {
                            finalAnswer = finalAnswer ? `${finalAnswer}|其他:${q.other.trim()}` : `其他:${q.other.trim()}`;
                        }
                        return [{ ...base, answer: finalAnswer }];
                    }

                    let answerValue = '';
                    
                    if (q.type.includes('配分單選題')) {
                        if (q.select) {
                            // 選到option物件
                            if (typeof q.select === 'object' && q.select.option_id) {
                                answerValue = String(q.select.option_id);
                            // 選到其他選項但沒有option_id
                            } else if (typeof q.select === 'object' && q.select.t) {
                                const matchedOpt = q.opts.find(opt => opt.t === q.select.t);
                                if (matchedOpt && matchedOpt.option_id) {
                                    answerValue = String(matchedOpt.option_id);
                                } else {
                                    answerValue = String(q.select.t);
                                }
                            // 其他直接轉字串
                            } else {
                                answerValue = String(q.select);
                            }
                        }
                        
                        if (q.other && q.other.trim()) {
                            answerValue = answerValue ? `${answerValue}|其他:${q.other}` : `其他:${q.other}`;
                        }
                    } else if (q.type === '評分') {
                        if (q.select !== null && q.select !== undefined) {
                            answerValue = String(q.select);
                        } else {
                            answerValue = '';
                        }
                    } else if (q.type === '簡答' || q.type === '文字詳述') {
                        answerValue = q.select ? String(q.select) : '';
                    }

                    return [{ ...base, answer: String(answerValue || '') }];
                });
                // 組成payload
                const payload = {
                    year,
                    questionnaire_id: questionnaireId,
                    fill_date: this.survey.date,
                    fill_time: fillDateTime.toISOString(),
                    answers: answers
                };

                const response = await axios.post('/api/Questionnaire/Answer', payload);

                if (response.data.status) {
                    this.snackbar = true;
                    this.survey.date = '';
                    this.survey.time = '';
                    this.survey.route = '';
                    this.questions.forEach(q => {
                        q.select = q.type.includes('複選題') ? [] : null;
                        q.other = '';
                        q.otherChecked = false;
                        q.isOtherSelected = false;
                    });
                } else {
                    alert(response.data.message || '儲存失敗');
                }
            } catch (error) {
                console.error('儲存問卷答案錯誤:', error);
                alert('儲存失敗: ' + (error.response?.data?.message || error.message));
            }
        },
    },
    // 監聽selectedYear的變化
    watch: {
		'$store.state.selectedYear'() {
			this.loadRouteList();
		},
	},
    // 初始化
    async mounted() {
        await this.loadRouteList();
    },
};
</script>